module.exports = __webpack_public_path__ + "static/media/038-online-tracking.da1b3b5a.svg";